import React from 'react';

// Eyebrow + heading + supporting copy block rendered inside an AuthShell
// card. Presentational only; content/copy varies per view state.
// `headingRef` is optional: multi-step flows (Register V2) use it to move
// focus to the new step's heading, since there is no natural focus target
// after a step transition that doesn't reload the page.
export default function AuthHeader({ eyebrow, title, subtitle, headingRef }) {
  return (
    <header className="auth-card-header">
      {eyebrow && <p className="auth-eyebrow">{eyebrow}</p>}
      {title && <h1 className="auth-title" ref={headingRef} tabIndex={-1}>{title}</h1>}
      {subtitle && <p className="auth-subtitle">{subtitle}</p>}
    </header>
  );
}
